import { getAuth } from "firebase/auth";

export const getAuthToken = async (): Promise<string | null> => {
  const auth = getAuth();
  const currentUser = auth.currentUser;
  if (!currentUser) throw new Error("User token not found");
  return currentUser.getIdToken();
}; 